import React from "react";
import { Link, useLocation } from "react-router-dom";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Tooltip from "@mui/material/Tooltip";
import { NavItem } from "./navItems";

interface MenuItemsProps {
  items: NavItem[];
  open: boolean;
  onNavigate?: () => void;
}

// Ported from BloomABA's MenuItems so both apps share the same nav look.
const MenuItems = ({ items, open, onNavigate }: MenuItemsProps) => {
  const { pathname } = useLocation();

  const isActive = (path: string) =>
    pathname === path || pathname.startsWith(`${path}/`);

  return (
    <List>
      {items.map((item) => (
        <ListItem key={item.id} disablePadding sx={{ display: "block" }}>
          <Tooltip
            title={item.title}
            placement="right"
            disableHoverListener={open}
            disableFocusListener={open}
            disableTouchListener={open}
          >
            <ListItemButton
              component={Link}
              to={item.path}
              onClick={onNavigate}
              selected={isActive(item.path)}
              aria-label={!open ? item.title : undefined}
              sx={[
                {
                  minHeight: 48,
                  px: 2.5,
                  cursor: "pointer",
                  "&.Mui-selected": {
                    bgcolor: "primary.light",
                    color: "primary.main",
                    "& .MuiListItemIcon-root": {
                      color: "primary.main",
                    },
                    "&:hover": {
                      bgcolor: "primary.light",
                    },
                  },
                },
                open
                  ? { justifyContent: "initial" }
                  : { justifyContent: "center" },
              ]}
            >
              <ListItemIcon
                sx={[
                  {
                    minWidth: 0,
                    justifyContent: "center",
                  },
                  open ? { mr: 3 } : { mr: "auto" },
                ]}
              >
                {item.icon}
              </ListItemIcon>
              <ListItemText
                primary={item.title}
                sx={[open ? { opacity: 1 } : { opacity: 0 }]}
                slotProps={{
                  primary: {
                    noWrap: true,
                    sx: {
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    },
                  },
                }}
              />
            </ListItemButton>
          </Tooltip>
        </ListItem>
      ))}
    </List>
  );
};

export default MenuItems;
